// 题号默认匹配正则 : Q + 数字
export const numReg = /Q[1-9]\d{0,}$/;
// 题号输入匹配正则 第一位为字母或数字 + 字母或数字
export const numEditReg = /^([a-zA-z]|[1-9]){1}(\d){0,}$/; 
// 手机号
export const phoneNumberReg = /^1(3\d|4[5-9]|5[0-35-9]|6[567]|7[0-8]|8\d|9[0-35-9])\d{8}$/; 
// 邮箱 
export const emailReg = /^\w{3,}(\.\w+)*@[A-z0-9]+(\.[A-z]{2,5}){1,2}$/; 
// 文字
export const textReg = /^[\u4e00-\u9fa5]{0,}$/;
// 数字
export const numberReg = /^[0-9]{0,}$/;
// 英文字母
export const letterReg = /^[A-Za-z]+$/;
// 日期
export const dateReg = /^\d{4}-\d{1,2}-\d{1,2}$/;


